import { staticComponentValueConverter } from '../StaticComponentValues';
import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';
import 'react-quill/dist/quill.snow.css';
import { useMemo, useRef, useEffect } from 'react';
function RichText_1({ item, imageWidth, aspectRatio, activeBigger, isCentered }) {
  const images = item?.data?.images || []
  const min = item?.variantData?.minImage
  const syntaxRef = useRef(null);
  const customization = staticComponentValueConverter(item?.customization)
  const iconFilter = useMemo(() => HexToHueConverter(customization?.iconColor), [customization?.iconColor]);
  useEffect(() => {
    if (syntaxRef.current) {
      const nodes = syntaxRef.current.querySelectorAll(".ql-syntax");

      nodes.forEach(element => {
        const iframe = document.createElement("iframe");
        iframe.height = "100%"
        iframe.width = "100%"
        const newElement = document.createElement("p");
        const newStyle = document.createElement("style")
        newStyle.innerHTML = `
        html{
          overflow-y: overlay;
        }
        
  
      `
        // Copy over attributes from the old element to the new one
        for (let i = 0; i < element.attributes.length; i++) {
          const attr = element.attributes[i];
          newElement.setAttribute(attr.name, attr.value);
        }

        newElement.classList.remove("ql-syntax");
        newElement.innerHTML = element.innerText;
        newElement.classList.add("no-scrollbar")
        const parentNode = element.parentNode
        parentNode.replaceChild(iframe, element);
        const domIframe = parentNode.querySelector("iframe")
        domIframe.contentDocument.write(newElement.outerHTML + newStyle.outerHTML)
      });
    }
  }, [item.data.text]);

  return (

    <>
      {item?.data?.text?.length > 0 ? <div className="overflow-hidden w-full"
        style={{
          padding: `${customization?.containerPadding}`,
          backgroundColor: customization?.backgroundType === "backgroundColor" ? customization?.backgroundColor : "",
          backgroundImage: customization?.backgroundType === "backgroundImage" ? `url(${customization?.backgroundImage})` : "",
          backgroundSize: "cover",
          backgroundPosition: "center center",
          height: customization?.height
        }}
      >
        <div className='p-editor-content ql-container ql-snow  no-scrollbar ' ref={syntaxRef} style={{ border: "0px" }}>
          <div className='ql-editor w-full no-scrollbar ' dangerouslySetInnerHTML={{ __html: item.data.text }} style={{ padding: "0px" }}>
          </div>
        </div>
      </div> :

        <img src={item?.placeholderImage} className={` w-full `} />}
    </>


  );
}

export default RichText_1;